import { MountingPortal } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/portal_vue_vue3.js?vue3';
import { uniqueId } from 'lodash-es';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'PanelActionsPortal',
    components: {
        MountingPortal
    },
    mixins: [
        glSlotsMixin
    ],
    data () {
        return {
            resolvedSelector: null
        };
    },
    mounted () {
        const panelView = this.$el.closest(this.$options.panelSelector);
        if (!panelView) return;
        const target = panelView.querySelector(this.$options.targetSelector);
        if (!target) return;
        if (!target.id) {
            target.id = uniqueId('panel-actions-portal-target-');
        }
        this.resolvedSelector = `#${target.id}`;
    },
    panelSelector: '.js-paneled-view',
    targetSelector: '.js-panel-actions-portal-target'
};
